import { useState, useEffect } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import './Sidebar.css'

export default function Sidebar() {
  const location = useLocation()
  const { user } = useAuth()
  const [expandedCategory, setExpandedCategory] = useState<string>('')

  const toggleCategory = (categoryId: string) => {
    setExpandedCategory(expandedCategory === categoryId ? '' : categoryId)
  }

  const categories = [
    {
      id: 'gas-calculations',
      label: 'Gas Calculations',
      items: [
        { id: 'gas-choke', label: 'Gas Choke Rate', path: '/calculators/gas-choke' },
        { id: 'gas-velocity', label: 'Gas Velocity', path: '/calculators/gas-velocity' },
        { id: 'z-factor', label: 'Gas Compressibility (Z-Factor)', path: '/calculators/z-factor' },
        { id: 'gor2', label: 'GOR2 Computation', path: '/calculators/gor2' }
      ]
    },
    {
      id: 'oil-calculations',
      label: 'Oil Calculations',
      items: [
        { id: 'combined-meter', label: 'Combined Meter Factor', path: '/calculators/combined-meter' },
        { id: 'katz-shrinkage', label: 'Katz Shrinkage', path: '/calculators/katz-shrinkage' },
        { id: 'shrinkage', label: 'Shrinkage', path: '/calculators/shrinkage' },
        { id: 'specific-gravity', label: 'Specific Gravity', path: '/calculators/specific-gravity' },
        { id: 'volume-correction', label: 'Volume Correction Factor', path: '/calculators/volume-correction' }
      ]
    },
    {
      id: 'well-control',
      label: 'Well Control',
      items: [
        { id: 'kill-fluid', label: 'Kill Fluid Calculation', path: '/calculators/kill-fluid' }
      ]
    },
    {
      id: 'conversions',
      label: 'Conversions',
      items: [
        { id: 'pressure', label: 'Pressure', path: '/converters/pressure' },
        { id: 'temperature', label: 'Temperature', path: '/converters/temperature' },
        { id: 'volume', label: 'Volume', path: '/converters/volume' },
        { id: 'density', label: 'Density', path: '/converters/density' }
      ]
    },
    {
      id: 'api',
      label: 'API Access',
      items: [
        { id: 'api-keys', label: 'API Keys', path: '/api/keys' },
        { id: 'api-docs', label: 'Documentation', path: '/api/docs' },
        { id: 'api-test', label: 'Test API', path: '/api/test' }
      ]
    }
  ]

  useEffect(() => {
    const currentCategory = categories.find(cat =>
      cat.items.some(item => item.path === location.pathname)
    )
    if (currentCategory && expandedCategory !== currentCategory.id) {
      setExpandedCategory(currentCategory.id)
    }
  }, [location.pathname])

  return (
    <aside className="sidebar">
      <nav className="sidebar-nav">
        <NavLink
          to="/"
          className={({ isActive }) => `home-link ${isActive ? 'active' : ''}`}
        >
          Home
        </NavLink>
        {user && (
          <NavLink
            to="/saved"
            className={({ isActive }) => `home-link ${isActive ? 'active' : ''}`}
          >
            Saved Calculations
          </NavLink>
        )}
        {categories.map(category => (
          <div key={category.id} className={`category ${expandedCategory === category.id ? 'expanded' : ''}`}>
            <button
              className="category-heading"
              onClick={() => toggleCategory(category.id)}
            >
              {category.label}
              <span className="category-arrow">▼</span>
            </button>
            <div className="category-items">
              {category.items.map(item => (
                <NavLink
                  key={item.id}
                  to={item.path}
                  className={({ isActive }) => `item-button ${isActive ? 'active' : ''}`}
                >
                  {item.label}
                </NavLink>
              ))}
            </div>
          </div>
        ))}
      </nav>
    </aside>
  )
}
